import { SelectedItems as OrdersSelectedItems } from '@modules/Orders/ViewOrders/components/display/SelectedItems';
import { FC } from 'react';
import type { OrderLine } from '@modules/Orders/ViewOrders/models/Order';

interface SelectedItemsProps {
  lines?: OrderLine[];
  totalShipping?: number;
  totalDiscount?: number;
  currency?: string;
  orderId?: number;
  statusId?: number;
  onUpdate?: () => void;
}

export const SelectedItems: FC<SelectedItemsProps> = (props) => {
  return <OrdersSelectedItems {...props} />;
};
